

export const isSmallDevice = window.matchMedia("(max-width: 700px)").matches